module.exports = __webpack_public_path__ + "img/the-importance-of-gateways-and-anchors.25b1f8fd.png";